let BASE_URL = "";

switch (process.env.REACT_APP_ENVIRONMENT) {
  case "prod":
    BASE_URL = process.env.REACT_APP_BASE_URL_PROD;
    break;
  case "test":
    BASE_URL = process.env.REACT_APP_BASE_URL_TEST;
    break;
  default:
    BASE_URL = process.env.REACT_APP_BASE_URL_DEV;
}

export { BASE_URL };

export const CONFIG = {
  BASE_URL,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  AZURE: {
    CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
    TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID,
    REDIRECT_URI: process.env.REACT_APP_AZURE_REDIRECT_URI,
  },
};
